import { FormattedMessage } from 'react-intl';

import MignifyingGlassNoColor from 'images/mignifying-glass-no-color.svg';

import * as S from './styles';

const ChatListEmptyState: React.FC = () => (
  <S.NoResults data-testid="chatListNoResults">
    <MignifyingGlassNoColor />
    <S.NoResultText>
      <FormattedMessage id="CHAT.LIST.NO_RESULT" />
    </S.NoResultText>
  </S.NoResults>
);

export default ChatListEmptyState;
